// extracted by mini-css-extract-plugin
export default {"romms_wrapper":"rooms_romms_wrapper__ZKTR2"};